import React from 'react';
import Home from '../Components/Home';

const SignUp = () => {
  return <Home menu='signUp' />;
};

export default SignUp;
